import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import * as d3 from 'd3'
import { ref, toRefs } from 'vue'
import { useComponent } from './useComponent'

export type HighlightLineProps = {
  stroke: string
  strokeWidth?: number
  xLimits: [number, number]
  yLimits: [number, number]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HighlightLineComponent',
  props: {
    stroke: {},
    strokeWidth: {},
    xLimits: {},
    yLimits: {}
  },
  setup(__props: any) {

const props = __props

const { stroke, xLimits, strokeWidth } = toRefs(props)

const group = ref<SVGGElement | null>(null)

useComponent(group, ({ width, height, group, parentGroup }) => {
  const xScale = d3.scaleLinear().domain(xLimits?.value).range([0, width])

  const line = group
    .append('line')
    .attr('stroke', stroke.value)
    .attr('display', 'none')
    .attr('stroke-width', strokeWidth?.value ?? 1)
    .attr('x1', 0)
    .attr('x2', 0)
    .attr('y1', 0)
    .attr('y2', height)

  let viewportRect: d3.Selection<SVGRectElement, unknown, null, undefined> =
    parentGroup.select('.viewport-rect')

  if (viewportRect.empty()) {
    viewportRect = parentGroup
      .append('rect')
      .classed('viewport-rect', true)
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('fill', 'transparent')
  }

  viewportRect
    .on('mousemove.highlight-line', onMouseMove)
    .on('mouseenter.highlight-line', () => {
      line.style('display', 'block')
    })
    .on('mouseleave.highlight-line', () => {
      line.style('display', 'none')
    })

  function onMouseMove() {
    const highlights = parentGroup.selectAll('.highlight')
    if (highlights.size() === 0) {
      line.style('display', 'none')
      return
    } else {
      line.style('display', 'block')
    }
    try {
      const meanX =
        [...highlights]
          .map((x) => d3.select(x))
          .map((highlight) => ({
            x: xScale(parseFloat(highlight.attr('data-x')))
          }))
          .reduce((acc, curr) => acc + curr.x, 0) / highlights.size()
      line.attr('x1', meanX).attr('x2', meanX)
    } catch (e) {}
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", {
    ref_key: "group",
    ref: group
  }, null, 512))
}
}

})